import sc, {keyframes} from 'styled-components';
import {Layout, UnifonTheme} from '@phonectas/unifon-ui-kit';

export interface SkeletonStyleProps {
  $dark?: boolean;
  theme?: UnifonTheme;
  $width?: number | undefined;
  $height?: number | undefined;
  $noPadding?: boolean;
  $noMargin?: boolean;
}

const pulseKeyframe = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
`;

export const StyledSkeleton = sc(Layout)<SkeletonStyleProps>`
	animation: ${pulseKeyframe} 1.5s ease-in-out 0.5s infinite;
	background-color: ${({theme, $dark}) => $dark ? theme.palette.secondary : theme.palette.lightSecondary};
	border-radius: ${({theme}) => theme.borderRadius * 2}px;
    width: ${({$width}) => $width ? `${$width}px` : '100%'};
    height: ${({$height}) => $height ? `${$height}px` : '100%'};
	min-width: ${({$width}) => $width ? `${$width}px` : '100%'};
	min-height: ${({$height}) => $height ? `${$height}px` : '100%'};
	${({$noPadding}) => $noPadding && 'padding: 0;'}
    ${({$noMargin}) => $noMargin && 'margin: 0;'}
`;